import React from "react";
import { DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuTrigger } from "@/components/ui/dropdown-menu";
import { Table2, Download, FileImage, FileText, Code2, Sheet } from "lucide-react";
import { exportWidget } from "@/lib/widgetExport";

const NO_DATA_ACTIONS = ["text", "image", "slicer", "multi_filter", "combo_box", "list_box", "date_picker", "container"];

// Item 26: widget actions available while previewing and on published / shared dashboards —
// underlying data plus widget-only exports, always in the widget's current filter context.
export function WidgetViewActions({ widget, filters = [], publicToken = null, whatIfParams = null,
  onUnderlying, canExport = true, crossDataset = false, testidPrefix = "widget" }) {
  if (!widget || NO_DATA_ACTIONS.includes(widget.type) || !widget.dataset_id) return null;
  const run = (fmt) => exportWidget({ widget, fmt, filters, publicToken, whatIfParams });
  return (
    <span className="flex items-center gap-0.5" data-testid={`${testidPrefix}-view-actions`}>
      {onUnderlying && !crossDataset && (
        <button data-testid="widget-underlying-btn" title="View underlying data"
          onClick={(e) => { e.stopPropagation(); onUnderlying(widget, filters); }}
          className="p-0.5 text-[color:var(--ink-3)] hover:text-[color:var(--brand-ocean)]">
          <Table2 className="w-3.5 h-3.5" />
        </button>
      )}
      {canExport && (
        <DropdownMenu>
          <DropdownMenuTrigger asChild>
            <button data-testid="widget-export-btn" title="Export this widget" onClick={(e) => e.stopPropagation()}
              className="p-0.5 text-[color:var(--ink-3)] hover:text-[color:var(--brand-ocean)]">
              <Download className="w-3.5 h-3.5" />
            </button>
          </DropdownMenuTrigger>
          <DropdownMenuContent align="end" onClick={(e) => e.stopPropagation()}>
            <DropdownMenuItem data-testid="widget-export-png" onClick={() => run("png")}><FileImage className="w-4 h-4 mr-2" />PNG image</DropdownMenuItem>
            <DropdownMenuItem data-testid="widget-export-pdf" onClick={() => run("pdf")}><FileText className="w-4 h-4 mr-2" />PDF snapshot</DropdownMenuItem>
            {!crossDataset && <DropdownMenuItem data-testid="widget-export-excel" onClick={() => run("excel")}><Sheet className="w-4 h-4 mr-2" />Data as Excel (styled)</DropdownMenuItem>}
            {!crossDataset && <DropdownMenuItem data-testid="widget-export-csv" onClick={() => run("csv")}><Download className="w-4 h-4 mr-2" />Data as CSV</DropdownMenuItem>}
            {!crossDataset && !publicToken && <DropdownMenuItem data-testid="widget-export-json" onClick={() => run("json")}><Code2 className="w-4 h-4 mr-2" />Data as JSON</DropdownMenuItem>}
          </DropdownMenuContent>
        </DropdownMenu>
      )}
    </span>
  );
}
